import * as React from 'react'
export const SvgBurgerIcon = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width={24} height={24} {...props}>
    <path d="M3 11h18v2H3v-2zm0-5h18v2H3V6zm0 10h18v2H3v-2z" />
  </svg>
)
export default SvgBurgerIcon
